import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import RefreshIcon from '@mui/icons-material/Refresh';
import {Box, Button, Typography} from '@mui/material';
import {array, func, node, number, oneOfType, string} from 'prop-types';
import React from 'react';
import EmptyMessage from './EmptyMessage.jsx';

export const ErrorMessage = ({
  children,
  componentName = 'page',
  error,
  message,
  onRetry,
  actions,
  statusCode,
  ...props
}) => {
  const defaultActions = [
    <Button
      key="supportButton"
      color="primary"
      variant="contained"
      href="https://support.planet.com/hc/en-us/requests/new"
      target="_blank"
      rel="noreferrer noopener"
      endIcon={<OpenInNewIcon fontSize="small" />}
    >
      Report Issue
    </Button>,
  ];

  if (onRetry) {
    defaultActions.push(
      <Button
        key="retryButton"
        color="primary"
        variant="outlined"
        onClick={() => onRetry()}
        startIcon={<RefreshIcon />}
      >
        Reload
      </Button>
    );
  }

  return (
    <EmptyMessage
      icon={<ErrorOutlineOutlinedIcon color="error" />}
      data-testid="error-message"
      title={
        <>
          Houston, we have a problem...
          {statusCode && (
            <Box component="span" sx={{marginTop: 1}}>
              {statusCode}
            </Box>
          )}
        </>
      }
      description={message}
      actions={actions || defaultActions}
      {...props}
    >
      {onRetry && (
        <Typography gutterBottom>
          Try reloading the {componentName} or let us know what happened.
        </Typography>
      )}
    </EmptyMessage>
  );
};

ErrorMessage.propTypes = {
  error: string,
  message: string,
  children: node,
  componentName: string,
  onRetry: func,
  actions: array,
  statusCode: oneOfType([string, number]),
};

export default ErrorMessage;
